import { useAuth0 as Yt, Auth0Provider as Gt, withAuthenticationRequired as mt, User as qt } from "@auth0/auth0-react";
import { User as lr, withAuthenticationRequired as fr } from "@auth0/auth0-react";
import te, { createContext as Qt, useContext as Xt, useState as Zt, useRef as bt, useEffect as be, useCallback as en } from "react";
var Fe = { exports: {} }, ae = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nt;
function tn() {
  if (nt)
    return ae;
  nt = 1;
  var r = te, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(u, l, f) {
    var d, h = {}, c = null, y = null;
    f !== void 0 && (c = "" + f), l.key !== void 0 && (c = "" + l.key), l.ref !== void 0 && (y = l.ref);
    for (d in l)
      n.call(l, d) && !i.hasOwnProperty(d) && (h[d] = l[d]);
    if (u && u.defaultProps)
      for (d in l = u.defaultProps, l)
        h[d] === void 0 && (h[d] = l[d]);
    return { $$typeof: e, type: u, key: c, ref: y, props: h, _owner: s.current };
  }
  return ae.Fragment = t, ae.jsx = o, ae.jsxs = o, ae;
}
var oe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rt;
function nn() {
  return rt || (rt = 1, process.env.NODE_ENV !== "production" && function() {
    var r = te, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), u = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), m = Symbol.iterator, O = "@@iterator";
    function R(a) {
      if (a === null || typeof a != "object")
        return null;
      var g = m && a[m] || a[O];
      return typeof g == "function" ? g : null;
    }
    var C = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(a) {
      {
        for (var g = arguments.length, p = new Array(g > 1 ? g - 1 : 0), b = 1; b < g; b++)
          p[b - 1] = arguments[b];
        M("error", a, p);
      }
    }
    function M(a, g, p) {
      {
        var b = C.ReactDebugCurrentFrame, w = b.getStackAddendum();
        w !== "" && (g += "%s", p = p.concat([w]));
        var E = p.map(function(S) {
          return String(S);
        });
        E.unshift("Warning: " + g), Function.prototype.apply.call(console[a], console, E);
      }
    }
    var L = !1, j = !1, F = !1, N = !1, T = !1, _;
    _ = Symbol.for("react.module.reference");
    function U(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === n || a === i || T || a === s || a === f || a === d || N || a === y || L || j || F || typeof a == "object" && a !== null && (a.$$typeof === c || a.$$typeof === h || a.$$typeof === o || a.$$typeof === u || a.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === _ || a.getModuleId !== void 0));
    }
    function $(a, g, p) {
      var b = a.displayName;
      if (b)
        return b;
      var w = g.displayName || g.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Ee(a) {
      return a.displayName || "Context";
    }
    function H(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case f:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case u:
            var g = a;
            return Ee(g) + ".Consumer";
          case o:
            var p = a;
            return Ee(p._context) + ".Provider";
          case l:
            return $(a, a.render, "ForwardRef");
          case h:
            var b = a.displayName || null;
            return b !== null ? b : H(a.type) || "Memo";
          case c: {
            var w = a, E = w._payload, S = w._init;
            try {
              return H(S(E));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var V = Object.assign, z = 0, G, re, I, W, Y, se, Ve;
    function Me() {
    }
    Me.__reactDisabledLog = !0;
    function Rt() {
      {
        if (z === 0) {
          G = console.log, re = console.info, I = console.warn, W = console.error, Y = console.group, se = console.groupCollapsed, Ve = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: Me,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        z++;
      }
    }
    function wt() {
      {
        if (z--, z === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: V({}, a, {
              value: G
            }),
            info: V({}, a, {
              value: re
            }),
            warn: V({}, a, {
              value: I
            }),
            error: V({}, a, {
              value: W
            }),
            group: V({}, a, {
              value: Y
            }),
            groupCollapsed: V({}, a, {
              value: se
            }),
            groupEnd: V({}, a, {
              value: Ve
            })
          });
        }
        z < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ce;
    function ce(a, g, p) {
      {
        if (Ce === void 0)
          try {
            throw Error();
          } catch (w) {
            var b = w.stack.trim().match(/\n( *(at )?)/);
            Ce = b && b[1] || "";
          }
        return `
` + Ce + a;
      }
    }
    var Pe = !1, de;
    {
      var Et = typeof WeakMap == "function" ? WeakMap : Map;
      de = new Et();
    }
    function Ke(a, g) {
      if (!a || Pe)
        return "";
      {
        var p = de.get(a);
        if (p !== void 0)
          return p;
      }
      var b;
      Pe = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var E;
      E = Le.current, Le.current = null, Rt();
      try {
        if (g) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (J) {
              b = J;
            }
            Reflect.construct(a, [], S);
          } else {
            try {
              S.call();
            } catch (J) {
              b = J;
            }
            a.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (J) {
            b = J;
          }
          a();
        }
      } catch (J) {
        if (J && b && typeof J.stack == "string") {
          for (var x = J.stack.split(`
`), D = b.stack.split(`
`), P = x.length - 1, k = D.length - 1; P >= 1 && k >= 0 && x[P] !== D[k]; )
            k--;
          for (; P >= 1 && k >= 0; P--, k--)
            if (x[P] !== D[k]) {
              if (P !== 1 || k !== 1)
                do
                  if (P--, k--, k < 0 || x[P] !== D[k]) {
                    var K = `
` + x[P].replace(" at new ", " at ");
                    return a.displayName && K.includes("<anonymous>") && (K = K.replace("<anonymous>", a.displayName)), typeof a == "function" && de.set(a, K), K;
                  }
                while (P >= 1 && k >= 0);
              break;
            }
        }
      } finally {
        Pe = !1, Le.current = E, wt(), Error.prepareStackTrace = w;
      }
      var X = a ? a.displayName || a.name : "", tt = X ? ce(X) : "";
      return typeof a == "function" && de.set(a, tt), tt;
    }
    function Lt(a, g, p) {
      return Ke(a, !1);
    }
    function Ct(a) {
      var g = a.prototype;
      return !!(g && g.isReactComponent);
    }
    function ge(a, g, p) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return Ke(a, Ct(a));
      if (typeof a == "string")
        return ce(a);
      switch (a) {
        case f:
          return ce("Suspense");
        case d:
          return ce("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case l:
            return Lt(a.render);
          case h:
            return ge(a.type, g, p);
          case c: {
            var b = a, w = b._payload, E = b._init;
            try {
              return ge(E(w), g, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, He = {}, ze = C.ReactDebugCurrentFrame;
    function pe(a) {
      if (a) {
        var g = a._owner, p = ge(a.type, a._source, g ? g.type : null);
        ze.setExtraStackFrame(p);
      } else
        ze.setExtraStackFrame(null);
    }
    function Pt(a, g, p, b, w) {
      {
        var E = Function.call.bind(he);
        for (var S in a)
          if (E(a, S)) {
            var x = void 0;
            try {
              if (typeof a[S] != "function") {
                var D = Error((b || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw D.name = "Invariant Violation", D;
              }
              x = a[S](g, S, b, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (P) {
              x = P;
            }
            x && !(x instanceof Error) && (pe(w), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", b || "React class", p, S, typeof x), pe(null)), x instanceof Error && !(x.message in He) && (He[x.message] = !0, pe(w), v("Failed %s type: %s", p, x.message), pe(null));
          }
      }
    }
    var Nt = Array.isArray;
    function Ne(a) {
      return Nt(a);
    }
    function Tt(a) {
      {
        var g = typeof Symbol == "function" && Symbol.toStringTag, p = g && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return p;
      }
    }
    function kt(a) {
      try {
        return We(a), !1;
      } catch {
        return !0;
      }
    }
    function We(a) {
      return "" + a;
    }
    function Be(a) {
      if (kt(a))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Tt(a)), We(a);
    }
    var ie = C.ReactCurrentOwner, jt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Je, Ye, Te;
    Te = {};
    function $t(a) {
      if (he.call(a, "ref")) {
        var g = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function At(a) {
      if (he.call(a, "key")) {
        var g = Object.getOwnPropertyDescriptor(a, "key").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function Ft(a, g) {
      if (typeof a.ref == "string" && ie.current && g && ie.current.stateNode !== g) {
        var p = H(ie.current.type);
        Te[p] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(ie.current.type), a.ref), Te[p] = !0);
      }
    }
    function It(a, g) {
      {
        var p = function() {
          Je || (Je = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        p.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function Dt(a, g) {
      {
        var p = function() {
          Ye || (Ye = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        p.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _t = function(a, g, p, b, w, E, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: a,
        key: g,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: E
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: b
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Ut(a, g, p, b, w) {
      {
        var E, S = {}, x = null, D = null;
        p !== void 0 && (Be(p), x = "" + p), At(g) && (Be(g.key), x = "" + g.key), $t(g) && (D = g.ref, Ft(g, w));
        for (E in g)
          he.call(g, E) && !jt.hasOwnProperty(E) && (S[E] = g[E]);
        if (a && a.defaultProps) {
          var P = a.defaultProps;
          for (E in P)
            S[E] === void 0 && (S[E] = P[E]);
        }
        if (x || D) {
          var k = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          x && It(S, k), D && Dt(S, k);
        }
        return _t(a, x, D, w, b, ie.current, S);
      }
    }
    var ke = C.ReactCurrentOwner, Ge = C.ReactDebugCurrentFrame;
    function Q(a) {
      if (a) {
        var g = a._owner, p = ge(a.type, a._source, g ? g.type : null);
        Ge.setExtraStackFrame(p);
      } else
        Ge.setExtraStackFrame(null);
    }
    var je;
    je = !1;
    function $e(a) {
      return typeof a == "object" && a !== null && a.$$typeof === e;
    }
    function qe() {
      {
        if (ke.current) {
          var a = H(ke.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function Vt(a) {
      {
        if (a !== void 0) {
          var g = a.fileName.replace(/^.*[\\\/]/, ""), p = a.lineNumber;
          return `

Check your code at ` + g + ":" + p + ".";
        }
        return "";
      }
    }
    var Qe = {};
    function Mt(a) {
      {
        var g = qe();
        if (!g) {
          var p = typeof a == "string" ? a : a.displayName || a.name;
          p && (g = `

Check the top-level render call using <` + p + ">.");
        }
        return g;
      }
    }
    function Xe(a, g) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var p = Mt(g);
        if (Qe[p])
          return;
        Qe[p] = !0;
        var b = "";
        a && a._owner && a._owner !== ke.current && (b = " It was passed a child from " + H(a._owner.type) + "."), Q(a), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, b), Q(null);
      }
    }
    function Ze(a, g) {
      {
        if (typeof a != "object")
          return;
        if (Ne(a))
          for (var p = 0; p < a.length; p++) {
            var b = a[p];
            $e(b) && Xe(b, g);
          }
        else if ($e(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var w = R(a);
          if (typeof w == "function" && w !== a.entries)
            for (var E = w.call(a), S; !(S = E.next()).done; )
              $e(S.value) && Xe(S.value, g);
        }
      }
    }
    function Kt(a) {
      {
        var g = a.type;
        if (g == null || typeof g == "string")
          return;
        var p;
        if (typeof g == "function")
          p = g.propTypes;
        else if (typeof g == "object" && (g.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        g.$$typeof === h))
          p = g.propTypes;
        else
          return;
        if (p) {
          var b = H(g);
          Pt(p, a.props, "prop", b, a);
        } else if (g.PropTypes !== void 0 && !je) {
          je = !0;
          var w = H(g);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof g.getDefaultProps == "function" && !g.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ht(a) {
      {
        for (var g = Object.keys(a.props), p = 0; p < g.length; p++) {
          var b = g[p];
          if (b !== "children" && b !== "key") {
            Q(a), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", b), Q(null);
            break;
          }
        }
        a.ref !== null && (Q(a), v("Invalid attribute `ref` supplied to `React.Fragment`."), Q(null));
      }
    }
    function et(a, g, p, b, w, E) {
      {
        var S = U(a);
        if (!S) {
          var x = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var D = Vt(w);
          D ? x += D : x += qe();
          var P;
          a === null ? P = "null" : Ne(a) ? P = "array" : a !== void 0 && a.$$typeof === e ? (P = "<" + (H(a.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : P = typeof a, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", P, x);
        }
        var k = Ut(a, g, p, w, E);
        if (k == null)
          return k;
        if (S) {
          var K = g.children;
          if (K !== void 0)
            if (b)
              if (Ne(K)) {
                for (var X = 0; X < K.length; X++)
                  Ze(K[X], a);
                Object.freeze && Object.freeze(K);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ze(K, a);
        }
        return a === n ? Ht(k) : Kt(k), k;
      }
    }
    function zt(a, g, p) {
      return et(a, g, p, !0);
    }
    function Wt(a, g, p) {
      return et(a, g, p, !1);
    }
    var Bt = Wt, Jt = zt;
    oe.Fragment = n, oe.jsx = Bt, oe.jsxs = Jt;
  }()), oe;
}
process.env.NODE_ENV === "production" ? Fe.exports = tn() : Fe.exports = nn();
var ne = Fe.exports;
const rn = {
  type: "logger",
  log(r) {
    this.output("log", r);
  },
  warn(r) {
    this.output("warn", r);
  },
  error(r) {
    this.output("error", r);
  },
  output(r, e) {
    console && console[r] && console[r].apply(console, e);
  }
};
class ye {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || rn, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, n, s) {
    return s && !this.debug ? null : (typeof e[0] == "string" && (e[0] = `${n}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new ye(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new ye(this.logger, e);
  }
}
var B = new ye();
class Oe {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const s = this.observers[n].get(t) || 0;
      this.observers[n].set(t, s + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
      n[s - 1] = arguments[s];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((o) => {
      let [u, l] = o;
      for (let f = 0; f < l; f++)
        u(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [u, l] = o;
      for (let f = 0; f < l; f++)
        u.apply(u, [e, ...n]);
    });
  }
}
function ue() {
  let r, e;
  const t = new Promise((n, s) => {
    r = n, e = s;
  });
  return t.resolve = r, t.reject = e, t;
}
function st(r) {
  return r == null ? "" : "" + r;
}
function sn(r, e, t) {
  r.forEach((n) => {
    e[n] && (t[n] = e[n]);
  });
}
const an = /###/g;
function le(r, e, t) {
  function n(u) {
    return u && u.indexOf("###") > -1 ? u.replace(an, ".") : u;
  }
  function s() {
    return !r || typeof r == "string";
  }
  const i = typeof e != "string" ? e : e.split(".");
  let o = 0;
  for (; o < i.length - 1; ) {
    if (s())
      return {};
    const u = n(i[o]);
    !r[u] && t && (r[u] = new t()), Object.prototype.hasOwnProperty.call(r, u) ? r = r[u] : r = {}, ++o;
  }
  return s() ? {} : {
    obj: r,
    k: n(i[o])
  };
}
function it(r, e, t) {
  const {
    obj: n,
    k: s
  } = le(r, e, Object);
  if (n !== void 0 || e.length === 1) {
    n[s] = t;
    return;
  }
  let i = e[e.length - 1], o = e.slice(0, e.length - 1), u = le(r, o, Object);
  for (; u.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), u = le(r, o, Object), u && u.obj && typeof u.obj[`${u.k}.${i}`] < "u" && (u.obj = void 0);
  u.obj[`${u.k}.${i}`] = t;
}
function on(r, e, t, n) {
  const {
    obj: s,
    k: i
  } = le(r, e, Object);
  s[i] = s[i] || [], n && (s[i] = s[i].concat(t)), n || s[i].push(t);
}
function ve(r, e) {
  const {
    obj: t,
    k: n
  } = le(r, e);
  if (t)
    return t[n];
}
function un(r, e, t) {
  const n = ve(r, t);
  return n !== void 0 ? n : ve(e, t);
}
function yt(r, e, t) {
  for (const n in e)
    n !== "__proto__" && n !== "constructor" && (n in r ? typeof r[n] == "string" || r[n] instanceof String || typeof e[n] == "string" || e[n] instanceof String ? t && (r[n] = e[n]) : yt(r[n], e[n], t) : r[n] = e[n]);
  return r;
}
function Z(r) {
  return r.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var ln = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function fn(r) {
  return typeof r == "string" ? r.replace(/[&<>"'\/]/g, (e) => ln[e]) : r;
}
class cn {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const n = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, n), this.regExpQueue.push(e), n;
  }
}
const dn = [" ", ",", "?", "!", ";"], gn = new cn(20);
function hn(r, e, t) {
  e = e || "", t = t || "";
  const n = dn.filter((o) => e.indexOf(o) < 0 && t.indexOf(o) < 0);
  if (n.length === 0)
    return !0;
  const s = gn.getRegExp(`(${n.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let i = !s.test(r);
  if (!i) {
    const o = r.indexOf(t);
    o > 0 && !s.test(r.substring(0, o)) && (i = !0);
  }
  return i;
}
function Ie(r, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!r)
    return;
  if (r[e])
    return r[e];
  const n = e.split(t);
  let s = r;
  for (let i = 0; i < n.length; ) {
    if (!s || typeof s != "object")
      return;
    let o, u = "";
    for (let l = i; l < n.length; ++l)
      if (l !== i && (u += t), u += n[l], o = s[u], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && l < n.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    s = o;
  }
  return s;
}
function xe(r) {
  return r && r.indexOf("_") > 0 ? r.replace("_", "-") : r;
}
class at extends Oe {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, o = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let u;
    e.indexOf(".") > -1 ? u = e.split(".") : (u = [e, t], n && (Array.isArray(n) ? u.push(...n) : typeof n == "string" && i ? u.push(...n.split(i)) : u.push(n)));
    const l = ve(this.data, u);
    return !l && !t && !n && e.indexOf(".") > -1 && (e = u[0], t = u[1], n = u.slice(2).join(".")), l || !o || typeof n != "string" ? l : Ie(this.data && this.data[e] && this.data[e][t], n, i);
  }
  addResource(e, t, n, s) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let u = [e, t];
    n && (u = u.concat(o ? n.split(o) : n)), e.indexOf(".") > -1 && (u = e.split("."), s = t, t = u[1]), this.addNamespaces(t), it(this.data, u, s), i.silent || this.emit("added", e, t, n, s);
  }
  addResources(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in n)
      (typeof n[i] == "string" || Object.prototype.toString.apply(n[i]) === "[object Array]") && this.addResource(e, t, i, n[i], {
        silent: !0
      });
    s.silent || this.emit("added", e, t, n);
  }
  addResourceBundle(e, t, n, s, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1
    }, u = [e, t];
    e.indexOf(".") > -1 && (u = e.split("."), s = n, n = t, t = u[1]), this.addNamespaces(t);
    let l = ve(this.data, u) || {};
    s ? yt(l, n, i) : l = {
      ...l,
      ...n
    }, it(this.data, u, l), o.silent || this.emit("added", e, t, n);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((s) => t[s] && Object.keys(t[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var vt = {
  processors: {},
  addPostProcessor(r) {
    this.processors[r.name] = r;
  },
  handle(r, e, t, n, s) {
    return r.forEach((i) => {
      this.processors[i] && (e = this.processors[i].process(e, t, n, s));
    }), e;
  }
};
const ot = {};
class Se extends Oe {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), sn(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = B.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const n = this.resolve(e, t);
    return n && n.res !== void 0;
  }
  extractFromKey(e, t) {
    let n = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const s = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let i = t.ns || this.options.defaultNS || [];
    const o = n && e.indexOf(n) > -1, u = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !hn(e, n, s);
    if (o && !u) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: i
        };
      const f = e.split(n);
      (n !== s || n === s && this.options.ns.indexOf(f[0]) > -1) && (i = f.shift()), e = f.join(s);
    }
    return typeof i == "string" && (i = [i]), {
      key: e,
      namespaces: i
    };
  }
  translate(e, t, n) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const s = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, i = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: u
    } = this.extractFromKey(e[e.length - 1], t), l = u[u.length - 1], f = t.lng || this.language, d = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (f && f.toLowerCase() === "cimode") {
      if (d) {
        const L = t.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${l}${L}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: f,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(t)
        } : `${l}${L}${o}`;
      }
      return s ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: f,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(t)
      } : o;
    }
    const h = this.resolve(e, t);
    let c = h && h.res;
    const y = h && h.usedKey || o, m = h && h.exactUsedKey || o, O = Object.prototype.toString.apply(c), R = ["[object Number]", "[object Function]", "[object RegExp]"], C = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (v && c && (typeof c != "string" && typeof c != "boolean" && typeof c != "number") && R.indexOf(O) < 0 && !(typeof C == "string" && O === "[object Array]")) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const L = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(y, c, {
          ...t,
          ns: u
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return s ? (h.res = L, h.usedParams = this.getUsedParamsDetails(t), h) : L;
      }
      if (i) {
        const L = O === "[object Array]", j = L ? [] : {}, F = L ? m : y;
        for (const N in c)
          if (Object.prototype.hasOwnProperty.call(c, N)) {
            const T = `${F}${i}${N}`;
            j[N] = this.translate(T, {
              ...t,
              joinArrays: !1,
              ns: u
            }), j[N] === T && (j[N] = c[N]);
          }
        c = j;
      }
    } else if (v && typeof C == "string" && O === "[object Array]")
      c = c.join(C), c && (c = this.extendTranslation(c, e, t, n));
    else {
      let L = !1, j = !1;
      const F = t.count !== void 0 && typeof t.count != "string", N = Se.hasDefaultValue(t), T = F ? this.pluralResolver.getSuffix(f, t.count, t) : "", _ = t.ordinal && F ? this.pluralResolver.getSuffix(f, t.count, {
        ordinal: !1
      }) : "", U = F && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), $ = U && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${T}`] || t[`defaultValue${_}`] || t.defaultValue;
      !this.isValidLookup(c) && N && (L = !0, c = $), this.isValidLookup(c) || (j = !0, c = o);
      const H = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && j ? void 0 : c, V = N && $ !== c && this.options.updateMissing;
      if (j || L || V) {
        if (this.logger.log(V ? "updateKey" : "missingKey", f, l, o, V ? $ : c), i) {
          const I = this.resolve(o, {
            ...t,
            keySeparator: !1
          });
          I && I.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let z = [];
        const G = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && G && G[0])
          for (let I = 0; I < G.length; I++)
            z.push(G[I]);
        else
          this.options.saveMissingTo === "all" ? z = this.languageUtils.toResolveHierarchy(t.lng || this.language) : z.push(t.lng || this.language);
        const re = (I, W, Y) => {
          const se = N && Y !== c ? Y : H;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(I, l, W, se, V, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(I, l, W, se, V, t), this.emit("missingKey", I, l, W, c);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && F ? z.forEach((I) => {
          const W = this.pluralResolver.getSuffixes(I, t);
          U && t[`defaultValue${this.options.pluralSeparator}zero`] && W.indexOf(`${this.options.pluralSeparator}zero`) < 0 && W.push(`${this.options.pluralSeparator}zero`), W.forEach((Y) => {
            re([I], o + Y, t[`defaultValue${Y}`] || $);
          });
        }) : re(z, o, $));
      }
      c = this.extendTranslation(c, e, t, h, n), j && c === o && this.options.appendNamespaceToMissingKey && (c = `${l}:${o}`), (j || L) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? c = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, L ? c : void 0) : c = this.options.parseMissingKeyHandler(c));
    }
    return s ? (h.res = c, h.usedParams = this.getUsedParamsDetails(t), h) : c;
  }
  extendTranslation(e, t, n, s, i) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const f = typeof e == "string" && (n && n.interpolation && n.interpolation.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let d;
      if (f) {
        const c = e.match(this.interpolator.nestingRegexp);
        d = c && c.length;
      }
      let h = n.replace && typeof n.replace != "string" ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (h = {
        ...this.options.interpolation.defaultVariables,
        ...h
      }), e = this.interpolator.interpolate(e, h, n.lng || this.language, n), f) {
        const c = e.match(this.interpolator.nestingRegexp), y = c && c.length;
        d < y && (n.nest = !1);
      }
      !n.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (n.lng = s.usedLng), n.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var c = arguments.length, y = new Array(c), m = 0; m < c; m++)
          y[m] = arguments[m];
        return i && i[0] === y[0] && !n.context ? (o.logger.warn(`It seems you are nesting recursively key: ${y[0]} in key: ${t[0]}`), null) : o.translate(...y, t);
      }, n)), n.interpolation && this.interpolator.reset();
    }
    const u = n.postProcess || this.options.postProcess, l = typeof u == "string" ? [u] : u;
    return e != null && l && l.length && n.applyPostProcessor !== !1 && (e = vt.handle(l, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n, s, i, o, u;
    return typeof e == "string" && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(n))
        return;
      const f = this.extractFromKey(l, t), d = f.key;
      s = d;
      let h = f.namespaces;
      this.options.fallbackNS && (h = h.concat(this.options.fallbackNS));
      const c = t.count !== void 0 && typeof t.count != "string", y = c && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = t.context !== void 0 && (typeof t.context == "string" || typeof t.context == "number") && t.context !== "", O = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      h.forEach((R) => {
        this.isValidLookup(n) || (u = R, !ot[`${O[0]}-${R}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(u) && (ot[`${O[0]}-${R}`] = !0, this.logger.warn(`key "${s}" for languages "${O.join(", ")}" won't get resolved as namespace "${u}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), O.forEach((C) => {
          if (this.isValidLookup(n))
            return;
          o = C;
          const v = [d];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, d, C, R, t);
          else {
            let L;
            c && (L = this.pluralResolver.getSuffix(C, t.count, t));
            const j = `${this.options.pluralSeparator}zero`, F = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (c && (v.push(d + L), t.ordinal && L.indexOf(F) === 0 && v.push(d + L.replace(F, this.options.pluralSeparator)), y && v.push(d + j)), m) {
              const N = `${d}${this.options.contextSeparator}${t.context}`;
              v.push(N), c && (v.push(N + L), t.ordinal && L.indexOf(F) === 0 && v.push(N + L.replace(F, this.options.pluralSeparator)), y && v.push(N + j));
            }
          }
          let M;
          for (; M = v.pop(); )
            this.isValidLookup(n) || (i = M, n = this.getResource(C, R, M, t));
        }));
      });
    }), {
      res: n,
      usedKey: s,
      exactUsedKey: i,
      usedLng: o,
      usedNS: u
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, n, s) : this.resourceStore.getResource(e, t, n, s);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = e.replace && typeof e.replace != "string";
    let s = n ? e.replace : e;
    if (n && typeof e.count < "u" && (s.count = e.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !n) {
      s = {
        ...s
      };
      for (const i of t)
        delete s[i];
    }
    return s;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const n in e)
      if (Object.prototype.hasOwnProperty.call(e, n) && t === n.substring(0, t.length) && e[n] !== void 0)
        return !0;
    return !1;
  }
}
function Ae(r) {
  return r.charAt(0).toUpperCase() + r.slice(1);
}
class ut {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = B.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = xe(e), !e || e.indexOf("-") < 0)
      return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = xe(e), !e || e.indexOf("-") < 0)
      return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (typeof e == "string" && e.indexOf("-") > -1) {
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let n = e.split("-");
      return this.options.lowerCaseLng ? n = n.map((s) => s.toLowerCase()) : n.length === 2 ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = Ae(n[1].toLowerCase()))) : n.length === 3 && (n[0] = n[0].toLowerCase(), n[1].length === 2 && (n[1] = n[1].toUpperCase()), n[0] !== "sgn" && n[2].length === 2 && (n[2] = n[2].toUpperCase()), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = Ae(n[1].toLowerCase())), t.indexOf(n[2].toLowerCase()) > -1 && (n[2] = Ae(n[2].toLowerCase()))), n.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let t;
    return e.forEach((n) => {
      if (t)
        return;
      const s = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (t = s);
    }), !t && this.options.supportedLngs && e.forEach((n) => {
      if (t)
        return;
      const s = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(s))
        return t = s;
      t = this.options.supportedLngs.find((i) => {
        if (i === s)
          return i;
        if (!(i.indexOf("-") < 0 && s.indexOf("-") < 0) && i.indexOf(s) === 0)
          return i;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(t)), typeof e == "string" && (e = [e]), Object.prototype.toString.apply(e) === "[object Array]")
      return e;
    if (!t)
      return e.default || [];
    let n = e[t];
    return n || (n = e[this.getScriptPartFromCode(t)]), n || (n = e[this.formatLanguageCode(t)]), n || (n = e[this.getLanguagePartFromCode(t)]), n || (n = e.default), n || [];
  }
  toResolveHierarchy(e, t) {
    const n = this.getFallbackCodes(t || this.options.fallbackLng || [], e), s = [], i = (o) => {
      o && (this.isSupportedCode(o) ? s.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return typeof e == "string" && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(e))) : typeof e == "string" && i(this.formatLanguageCode(e)), n.forEach((o) => {
      s.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), s;
  }
}
let pn = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], mn = {
  1: function(r) {
    return +(r > 1);
  },
  2: function(r) {
    return +(r != 1);
  },
  3: function(r) {
    return 0;
  },
  4: function(r) {
    return r % 10 == 1 && r % 100 != 11 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
  },
  5: function(r) {
    return r == 0 ? 0 : r == 1 ? 1 : r == 2 ? 2 : r % 100 >= 3 && r % 100 <= 10 ? 3 : r % 100 >= 11 ? 4 : 5;
  },
  6: function(r) {
    return r == 1 ? 0 : r >= 2 && r <= 4 ? 1 : 2;
  },
  7: function(r) {
    return r == 1 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
  },
  8: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : r != 8 && r != 11 ? 2 : 3;
  },
  9: function(r) {
    return +(r >= 2);
  },
  10: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : r < 7 ? 2 : r < 11 ? 3 : 4;
  },
  11: function(r) {
    return r == 1 || r == 11 ? 0 : r == 2 || r == 12 ? 1 : r > 2 && r < 20 ? 2 : 3;
  },
  12: function(r) {
    return +(r % 10 != 1 || r % 100 == 11);
  },
  13: function(r) {
    return +(r !== 0);
  },
  14: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : r == 3 ? 2 : 3;
  },
  15: function(r) {
    return r % 10 == 1 && r % 100 != 11 ? 0 : r % 10 >= 2 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
  },
  16: function(r) {
    return r % 10 == 1 && r % 100 != 11 ? 0 : r !== 0 ? 1 : 2;
  },
  17: function(r) {
    return r == 1 || r % 10 == 1 && r % 100 != 11 ? 0 : 1;
  },
  18: function(r) {
    return r == 0 ? 0 : r == 1 ? 1 : 2;
  },
  19: function(r) {
    return r == 1 ? 0 : r == 0 || r % 100 > 1 && r % 100 < 11 ? 1 : r % 100 > 10 && r % 100 < 20 ? 2 : 3;
  },
  20: function(r) {
    return r == 1 ? 0 : r == 0 || r % 100 > 0 && r % 100 < 20 ? 1 : 2;
  },
  21: function(r) {
    return r % 100 == 1 ? 1 : r % 100 == 2 ? 2 : r % 100 == 3 || r % 100 == 4 ? 3 : 0;
  },
  22: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : (r < 0 || r > 10) && r % 10 == 0 ? 2 : 3;
  }
};
const bn = ["v1", "v2", "v3"], yn = ["v4"], lt = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function vn() {
  const r = {};
  return pn.forEach((e) => {
    e.lngs.forEach((t) => {
      r[t] = {
        numbers: e.nr,
        plurals: mn[e.fc]
      };
    });
  }), r;
}
class xn {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = B.create("pluralResolver"), (!this.options.compatibilityJSON || yn.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = vn();
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(xe(e === "dev" ? "en" : e), {
          type: t.ordinal ? "ordinal" : "cardinal"
        });
      } catch {
        return;
      }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, t);
    return this.shouldUseIntlApi() ? n && n.resolvedOptions().pluralCategories.length > 1 : n && n.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, n).map((s) => `${t}${s}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, t);
    return n ? this.shouldUseIntlApi() ? n.resolvedOptions().pluralCategories.sort((s, i) => lt[s] - lt[i]).map((s) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : n.numbers.map((s) => this.getSuffix(e, s, t)) : [];
  }
  getSuffix(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(e, n);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(t)}` : this.getSuffixRetroCompatible(s, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const n = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let s = e.numbers[n];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const i = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? i() : this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
  }
  shouldUseIntlApi() {
    return !bn.includes(this.options.compatibilityJSON);
  }
}
function ft(r, e, t) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = un(r, e, t);
  return !i && s && typeof t == "string" && (i = Ie(r, t, n), i === void 0 && (i = Ie(e, t, n))), i;
}
class Sn {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = B.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const t = e.interpolation;
    this.escape = t.escape !== void 0 ? t.escape : fn, this.escapeValue = t.escapeValue !== void 0 ? t.escapeValue : !0, this.useRawValueToEscape = t.useRawValueToEscape !== void 0 ? t.useRawValueToEscape : !1, this.prefix = t.prefix ? Z(t.prefix) : t.prefixEscaped || "{{", this.suffix = t.suffix ? Z(t.suffix) : t.suffixEscaped || "}}", this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",", this.unescapePrefix = t.unescapeSuffix ? "" : t.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t.unescapeSuffix || "", this.nestingPrefix = t.nestingPrefix ? Z(t.nestingPrefix) : t.nestingPrefixEscaped || Z("$t("), this.nestingSuffix = t.nestingSuffix ? Z(t.nestingSuffix) : t.nestingSuffixEscaped || Z(")"), this.nestingOptionsSeparator = t.nestingOptionsSeparator ? t.nestingOptionsSeparator : t.nestingOptionsSeparator || ",", this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3, this.alwaysFormat = t.alwaysFormat !== void 0 ? t.alwaysFormat : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, n) => t && t.source === n ? (t.lastIndex = 0, t) : new RegExp(n, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, n, s) {
    let i, o, u;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function f(m) {
      return m.replace(/\$/g, "$$$$");
    }
    const d = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const v = ft(t, l, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(v, void 0, n, {
          ...s,
          ...t,
          interpolationkey: m
        }) : v;
      }
      const O = m.split(this.formatSeparator), R = O.shift().trim(), C = O.join(this.formatSeparator).trim();
      return this.format(ft(t, l, R, this.options.keySeparator, this.options.ignoreJSONStructure), C, n, {
        ...s,
        ...t,
        interpolationkey: R
      });
    };
    this.resetRegExp();
    const h = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, c = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => f(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? f(this.escape(m)) : f(m)
    }].forEach((m) => {
      for (u = 0; i = m.regex.exec(e); ) {
        const O = i[1].trim();
        if (o = d(O), o === void 0)
          if (typeof h == "function") {
            const C = h(e, i, s);
            o = typeof C == "string" ? C : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, O))
            o = "";
          else if (c) {
            o = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${O} for interpolating ${e}`), o = "";
        else
          typeof o != "string" && !this.useRawValueToEscape && (o = st(o));
        const R = m.safeValue(o);
        if (e = e.replace(i[0], R), c ? (m.regex.lastIndex += o.length, m.regex.lastIndex -= i[0].length) : m.regex.lastIndex = 0, u++, u >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, i, o;
    function u(l, f) {
      const d = this.nestingOptionsSeparator;
      if (l.indexOf(d) < 0)
        return l;
      const h = l.split(new RegExp(`${d}[ ]*{`));
      let c = `{${h[1]}`;
      l = h[0], c = this.interpolate(c, o);
      const y = c.match(/'/g), m = c.match(/"/g);
      (y && y.length % 2 === 0 && !m || m.length % 2 !== 0) && (c = c.replace(/'/g, '"'));
      try {
        o = JSON.parse(c), f && (o = {
          ...f,
          ...o
        });
      } catch (O) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, O), `${l}${d}${c}`;
      }
      return delete o.defaultValue, l;
    }
    for (; s = this.nestingRegexp.exec(e); ) {
      let l = [];
      o = {
        ...n
      }, o = o.replace && typeof o.replace != "string" ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let f = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const d = s[1].split(this.formatSeparator).map((h) => h.trim());
        s[1] = d.shift(), l = d, f = !0;
      }
      if (i = t(u.call(this, s[1].trim(), o), o), i && s[0] === e && typeof i != "string")
        return i;
      typeof i != "string" && (i = st(i)), i || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${e}`), i = ""), f && (i = l.reduce((d, h) => this.format(d, h, n.lng, {
        ...n,
        interpolationkey: s[1].trim()
      }), i.trim())), e = e.replace(s[0], i), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
function On(r) {
  let e = r.toLowerCase().trim();
  const t = {};
  if (r.indexOf("(") > -1) {
    const n = r.split("(");
    e = n[0].toLowerCase().trim();
    const s = n[1].substring(0, n[1].length - 1);
    e === "currency" && s.indexOf(":") < 0 ? t.currency || (t.currency = s.trim()) : e === "relativetime" && s.indexOf(":") < 0 ? t.range || (t.range = s.trim()) : s.split(";").forEach((o) => {
      if (!o)
        return;
      const [u, ...l] = o.split(":"), f = l.join(":").trim().replace(/^'+|'+$/g, "");
      t[u.trim()] || (t[u.trim()] = f), f === "false" && (t[u.trim()] = !1), f === "true" && (t[u.trim()] = !0), isNaN(f) || (t[u.trim()] = parseInt(f, 10));
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}
function ee(r) {
  const e = {};
  return function(n, s, i) {
    const o = s + JSON.stringify(i);
    let u = e[o];
    return u || (u = r(xe(s), i), e[o] = u), u(n);
  };
}
class Rn {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = B.create("formatter"), this.options = e, this.formats = {
      number: ee((t, n) => {
        const s = new Intl.NumberFormat(t, {
          ...n
        });
        return (i) => s.format(i);
      }),
      currency: ee((t, n) => {
        const s = new Intl.NumberFormat(t, {
          ...n,
          style: "currency"
        });
        return (i) => s.format(i);
      }),
      datetime: ee((t, n) => {
        const s = new Intl.DateTimeFormat(t, {
          ...n
        });
        return (i) => s.format(i);
      }),
      relativetime: ee((t, n) => {
        const s = new Intl.RelativeTimeFormat(t, {
          ...n
        });
        return (i) => s.format(i, n.range || "day");
      }),
      list: ee((t, n) => {
        const s = new Intl.ListFormat(t, {
          ...n
        });
        return (i) => s.format(i);
      })
    }, this.init(e);
  }
  init(e) {
    const n = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = ee(t);
  }
  format(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return t.split(this.formatSeparator).reduce((u, l) => {
      const {
        formatName: f,
        formatOptions: d
      } = On(l);
      if (this.formats[f]) {
        let h = u;
        try {
          const c = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, y = c.locale || c.lng || s.locale || s.lng || n;
          h = this.formats[f](u, y, {
            ...d,
            ...s,
            ...c
          });
        } catch (c) {
          this.logger.warn(c);
        }
        return h;
      } else
        this.logger.warn(`there was no format function for ${f}`);
      return u;
    }, e);
  }
}
function wn(r, e) {
  r.pending[e] !== void 0 && (delete r.pending[e], r.pendingCount--);
}
class En extends Oe {
  constructor(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = n, this.languageUtils = n.languageUtils, this.options = s, this.logger = B.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(n, s.backend, s);
  }
  queueLoad(e, t, n, s) {
    const i = {}, o = {}, u = {}, l = {};
    return e.forEach((f) => {
      let d = !0;
      t.forEach((h) => {
        const c = `${f}|${h}`;
        !n.reload && this.store.hasResourceBundle(f, h) ? this.state[c] = 2 : this.state[c] < 0 || (this.state[c] === 1 ? o[c] === void 0 && (o[c] = !0) : (this.state[c] = 1, d = !1, o[c] === void 0 && (o[c] = !0), i[c] === void 0 && (i[c] = !0), l[h] === void 0 && (l[h] = !0)));
      }), d || (u[f] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(u),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, n) {
    const s = e.split("|"), i = s[0], o = s[1];
    t && this.emit("failedLoading", i, o, t), n && this.store.addResourceBundle(i, o, n), this.state[e] = t ? -1 : 2;
    const u = {};
    this.queue.forEach((l) => {
      on(l.loaded, [i], o), wn(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((f) => {
        u[f] || (u[f] = {});
        const d = l.loaded[f];
        d.length && d.forEach((h) => {
          u[f][h] === void 0 && (u[f][h] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", u), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length)
      return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: n,
        tried: s,
        wait: i,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const u = (f, d) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const h = this.waitingReads.shift();
        this.read(h.lng, h.ns, h.fcName, h.tried, h.wait, h.callback);
      }
      if (f && d && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, n, s + 1, i * 2, o);
        }, i);
        return;
      }
      o(f, d);
    }, l = this.backend[n].bind(this.backend);
    if (l.length === 2) {
      try {
        const f = l(e, t);
        f && typeof f.then == "function" ? f.then((d) => u(null, d)).catch(u) : u(null, f);
      } catch (f) {
        u(f);
      }
      return;
    }
    return l(e, t, u);
  }
  prepareLoading(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    typeof e == "string" && (e = this.languageUtils.toResolveHierarchy(e)), typeof t == "string" && (t = [t]);
    const i = this.queueLoad(e, t, n, s);
    if (!i.toLoad.length)
      return i.pending.length || s(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(e, t, n) {
    this.prepareLoading(e, t, {}, n);
  }
  reload(e, t, n) {
    this.prepareLoading(e, t, {
      reload: !0
    }, n);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const n = e.split("|"), s = n[0], i = n[1];
    this.read(s, i, "read", void 0, void 0, (o, u) => {
      o && this.logger.warn(`${t}loading namespace ${i} for language ${s} failed`, o), !o && u && this.logger.log(`${t}loaded namespace ${i} for language ${s}`, u), this.loaded(e, o, u);
    });
  }
  saveMissing(e, t, n, s, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, u = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${n}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...o,
          isUpdate: i
        }, f = this.backend.create.bind(this.backend);
        if (f.length < 6)
          try {
            let d;
            f.length === 5 ? d = f(e, t, n, s, l) : d = f(e, t, n, s), d && typeof d.then == "function" ? d.then((h) => u(null, h)).catch(u) : u(null, d);
          } catch (d) {
            u(d);
          }
        else
          f(e, t, n, s, u, l);
      }
      !e || !e[0] || this.store.addResource(e[0], t, n, s);
    }
  }
}
function ct() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(e) {
      let t = {};
      if (typeof e[1] == "object" && (t = e[1]), typeof e[1] == "string" && (t.defaultValue = e[1]), typeof e[2] == "string" && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
        const n = e[3] || e[2];
        Object.keys(n).forEach((s) => {
          t[s] = n[s];
        });
      }
      return t;
    },
    interpolation: {
      escapeValue: !0,
      format: (r) => r,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function dt(r) {
  return typeof r.ns == "string" && (r.ns = [r.ns]), typeof r.fallbackLng == "string" && (r.fallbackLng = [r.fallbackLng]), typeof r.fallbackNS == "string" && (r.fallbackNS = [r.fallbackNS]), r.supportedLngs && r.supportedLngs.indexOf("cimode") < 0 && (r.supportedLngs = r.supportedLngs.concat(["cimode"])), r;
}
function me() {
}
function Ln(r) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(r)).forEach((t) => {
    typeof r[t] == "function" && (r[t] = r[t].bind(r));
  });
}
class fe extends Oe {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = dt(e), this.services = {}, this.logger = B, this.modules = {
      external: []
    }, Ln(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    typeof t == "function" && (n = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (typeof t.ns == "string" ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const s = ct();
    this.options = {
      ...s,
      ...this.options,
      ...dt(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    function i(d) {
      return d ? typeof d == "function" ? new d() : d : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? B.init(i(this.modules.logger), this.options) : B.init(null, this.options);
      let d;
      this.modules.formatter ? d = this.modules.formatter : typeof Intl < "u" && (d = Rn);
      const h = new ut(this.options);
      this.store = new at(this.options.resources, this.options);
      const c = this.services;
      c.logger = B, c.resourceStore = this.store, c.languageUtils = h, c.pluralResolver = new xn(h, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), d && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (c.formatter = i(d), c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new Sn(this.options), c.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, c.backendConnector = new En(i(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", function(y) {
        for (var m = arguments.length, O = new Array(m > 1 ? m - 1 : 0), R = 1; R < m; R++)
          O[R - 1] = arguments[R];
        e.emit(y, ...O);
      }), this.modules.languageDetector && (c.languageDetector = i(this.modules.languageDetector), c.languageDetector.init && c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = i(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new Se(this.services, this.options), this.translator.on("*", function(y) {
        for (var m = arguments.length, O = new Array(m > 1 ? m - 1 : 0), R = 1; R < m; R++)
          O[R - 1] = arguments[R];
        e.emit(y, ...O);
      }), this.modules.external.forEach((y) => {
        y.init && y.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = me), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const d = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      d.length > 0 && d[0] !== "dev" && (this.options.lng = d[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((d) => {
      this[d] = function() {
        return e.store[d](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((d) => {
      this[d] = function() {
        return e.store[d](...arguments), e;
      };
    });
    const l = ue(), f = () => {
      const d = (h, c) => {
        this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(c), n(h, c);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return d(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, d);
    };
    return this.options.resources || !this.options.initImmediate ? f() : setTimeout(f, 0), l;
  }
  loadResources(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : me;
    const s = typeof e == "string" ? e : this.language;
    if (typeof e == "function" && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return n();
      const i = [], o = (u) => {
        if (!u || u === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(u).forEach((f) => {
          f !== "cimode" && i.indexOf(f) < 0 && i.push(f);
        });
      };
      s ? o(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => o(l)), this.options.preload && this.options.preload.forEach((u) => o(u)), this.services.backendConnector.load(i, this.options.ns, (u) => {
        !u && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(u);
      });
    } else
      n(null);
  }
  reloadResources(e, t, n) {
    const s = ue();
    return e || (e = this.languages), t || (t = this.options.ns), n || (n = me), this.services.backendConnector.reload(e, t, (i) => {
      s.resolve(), n(i);
    }), s;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && vt.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const n = this.languages[t];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var n = this;
    this.isLanguageChangingTo = e;
    const s = ue();
    this.emit("languageChanging", e);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, f) => {
      f ? (i(f), this.translator.changeLanguage(f), this.isLanguageChangingTo = void 0, this.emit("languageChanged", f), this.logger.log("languageChanged", f)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return n.t(...arguments);
      }), t && t(l, function() {
        return n.t(...arguments);
      });
    }, u = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const f = typeof l == "string" ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      f && (this.language || i(f), this.translator.language || this.translator.changeLanguage(f), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(f)), this.loadResources(f, (d) => {
        o(d, f);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? u(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(u) : this.services.languageDetector.detect(u) : u(e), s;
  }
  getFixedT(e, t, n) {
    var s = this;
    const i = function(o, u) {
      let l;
      if (typeof u != "object") {
        for (var f = arguments.length, d = new Array(f > 2 ? f - 2 : 0), h = 2; h < f; h++)
          d[h - 2] = arguments[h];
        l = s.options.overloadTranslationOptionHandler([o, u].concat(d));
      } else
        l = {
          ...u
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix = l.keyPrefix || n || i.keyPrefix;
      const c = s.options.keySeparator || ".";
      let y;
      return l.keyPrefix && Array.isArray(o) ? y = o.map((m) => `${l.keyPrefix}${c}${m}`) : y = l.keyPrefix ? `${l.keyPrefix}${c}${o}` : o, s.t(y, l);
    };
    return typeof e == "string" ? i.lng = e : i.lngs = e, i.ns = t, i.keyPrefix = n, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = t.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode")
      return !0;
    const o = (u, l) => {
      const f = this.services.backendConnector.state[`${u}|${l}`];
      return f === -1 || f === 2;
    };
    if (t.precheck) {
      const u = t.precheck(this, o);
      if (u !== void 0)
        return u;
    }
    return !!(this.hasResourceBundle(n, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(n, e) && (!s || o(i, e)));
  }
  loadNamespaces(e, t) {
    const n = ue();
    return this.options.ns ? (typeof e == "string" && (e = [e]), e.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      n.resolve(), t && t(s);
    }), n) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const n = ue();
    typeof e == "string" && (e = [e]);
    const s = this.options.preload || [], i = e.filter((o) => s.indexOf(o) < 0);
    return i.length ? (this.options.preload = s.concat(i), this.loadResources((o) => {
      n.resolve(), t && t(o);
    }), n) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = this.services && this.services.languageUtils || new ut(ct());
    return t.indexOf(n.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new fe(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : me;
    const n = e.forkResourceStore;
    n && delete e.forkResourceStore;
    const s = {
      ...this.options,
      ...e,
      isClone: !0
    }, i = new fe(s);
    return (e.debug !== void 0 || e.prefix !== void 0) && (i.logger = i.logger.clone(e)), ["store", "services", "language"].forEach((u) => {
      i[u] = this[u];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, n && (i.store = new at(this.store.data, s), i.services.resourceStore = i.store), i.translator = new Se(i.services, s), i.translator.on("*", function(u) {
      for (var l = arguments.length, f = new Array(l > 1 ? l - 1 : 0), d = 1; d < l; d++)
        f[d - 1] = arguments[d];
      i.emit(u, ...f);
    }), i.init(s, t), i.translator.options = s, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const A = fe.createInstance();
A.createInstance = fe.createInstance;
A.createInstance;
A.dir;
A.init;
A.loadResources;
A.reloadResources;
A.use;
A.changeLanguage;
A.getFixedT;
A.t;
A.exists;
A.setDefaultNamespace;
A.hasLoadedNamespace;
A.loadNamespaces;
A.loadLanguages;
const Cn = (r, e, t, n) => {
  var i, o, u, l;
  const s = [t, {
    code: e,
    ...n || {}
  }];
  if ((o = (i = r == null ? void 0 : r.services) == null ? void 0 : i.logger) != null && o.forward)
    return r.services.logger.forward(s, "warn", "react-i18next::", !0);
  q(s[0]) && (s[0] = `react-i18next:: ${s[0]}`), (l = (u = r == null ? void 0 : r.services) == null ? void 0 : u.logger) != null && l.warn ? r.services.logger.warn(...s) : console != null && console.warn && console.warn(...s);
}, gt = {}, De = (r, e, t, n) => {
  q(t) && gt[t] || (q(t) && (gt[t] = /* @__PURE__ */ new Date()), Cn(r, e, t, n));
}, xt = (r, e) => () => {
  if (r.isInitialized)
    e();
  else {
    const t = () => {
      setTimeout(() => {
        r.off("initialized", t);
      }, 0), e();
    };
    r.on("initialized", t);
  }
}, _e = (r, e, t) => {
  r.loadNamespaces(e, xt(r, t));
}, ht = (r, e, t, n) => {
  if (q(t) && (t = [t]), r.options.preload && r.options.preload.indexOf(e) > -1)
    return _e(r, t, n);
  t.forEach((s) => {
    r.options.ns.indexOf(s) < 0 && r.options.ns.push(s);
  }), r.loadLanguages(e, xt(r, n));
}, Pn = (r, e, t = {}) => !e.languages || !e.languages.length ? (De(e, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: e.languages
}), !0) : e.hasLoadedNamespace(r, {
  lng: t.lng,
  precheck: (n, s) => {
    var i;
    if (((i = t.bindI18n) == null ? void 0 : i.indexOf("languageChanging")) > -1 && n.services.backendConnector.backend && n.isLanguageChangingTo && !s(n.isLanguageChangingTo, r))
      return !1;
  }
}), q = (r) => typeof r == "string", Nn = (r) => typeof r == "object" && r !== null, Tn = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, kn = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, jn = (r) => kn[r], $n = (r) => r.replace(Tn, jn);
let Ue = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: $n
};
const An = (r = {}) => {
  Ue = {
    ...Ue,
    ...r
  };
}, Fn = () => Ue;
let St;
const In = (r) => {
  St = r;
}, Dn = () => St, _n = {
  type: "3rdParty",
  init(r) {
    An(r.options.react), In(r);
  }
}, Un = Qt();
class Vn {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((t) => {
      this.usedNamespaces[t] || (this.usedNamespaces[t] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Mn = (r, e) => {
  const t = bt();
  return be(() => {
    t.current = e ? t.current : r;
  }, [r, e]), t.current;
}, Ot = (r, e, t, n) => r.getFixedT(e, t, n), Kn = (r, e, t, n) => en(Ot(r, e, t, n), [r, e, t, n]), Hn = (r, e = {}) => {
  var L, j, F, N;
  const {
    i18n: t
  } = e, {
    i18n: n,
    defaultNS: s
  } = Xt(Un) || {}, i = t || n || Dn();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new Vn()), !i) {
    De(i, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const T = (U, $) => q($) ? $ : Nn($) && q($.defaultValue) ? $.defaultValue : Array.isArray(U) ? U[U.length - 1] : U, _ = [T, {}, !1];
    return _.t = T, _.i18n = {}, _.ready = !1, _;
  }
  (L = i.options.react) != null && L.wait && De(i, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const o = {
    ...Fn(),
    ...i.options.react,
    ...e
  }, {
    useSuspense: u,
    keyPrefix: l
  } = o;
  let f = r || s || ((j = i.options) == null ? void 0 : j.defaultNS);
  f = q(f) ? [f] : f || ["translation"], (N = (F = i.reportNamespaces).addUsedNamespaces) == null || N.call(F, f);
  const d = (i.isInitialized || i.initializedStoreOnce) && f.every((T) => Pn(T, i, o)), h = Kn(i, e.lng || null, o.nsMode === "fallback" ? f : f[0], l), c = () => h, y = () => Ot(i, e.lng || null, o.nsMode === "fallback" ? f : f[0], l), [m, O] = Zt(c);
  let R = f.join();
  e.lng && (R = `${e.lng}${R}`);
  const C = Mn(R), v = bt(!0);
  be(() => {
    const {
      bindI18n: T,
      bindI18nStore: _
    } = o;
    v.current = !0, !d && !u && (e.lng ? ht(i, e.lng, f, () => {
      v.current && O(y);
    }) : _e(i, f, () => {
      v.current && O(y);
    })), d && C && C !== R && v.current && O(y);
    const U = () => {
      v.current && O(y);
    };
    return T && (i == null || i.on(T, U)), _ && (i == null || i.store.on(_, U)), () => {
      v.current = !1, i && (T == null || T.split(" ").forEach(($) => i.off($, U))), _ && i && _.split(" ").forEach(($) => i.store.off($, U));
    };
  }, [i, R]), be(() => {
    v.current && d && O(c);
  }, [i, l, d]);
  const M = [m, i, d];
  if (M.t = m, M.i18n = i, M.ready = d, d || !d && !u)
    return M;
  throw new Promise((T) => {
    e.lng ? ht(i, e.lng, f, () => T()) : _e(i, f, () => T());
  });
}, zn = {
  defaultError: "There was an error authenticating the user",
  unauthenticated: "The user is unauthenticated",
  notAuthorised: "User is unauthorised for this component",
  login: "Log In",
  loading: "Loading..."
}, Wn = {
  translation: zn
}, pt = ["en", "de", "es"];
A.use(_n).init({
  /* initReactI18next config */
  cleanCode: !0,
  fallbackLng: pt[0],
  load: "languageOnly",
  lowerCaseLng: !0,
  resources: {
    en: { ...Wn }
  },
  supportedLngs: pt
});
const Re = () => ({
  ...Yt()
});
function Bn({
  displayLogin: r = !0,
  message: e,
  isLoading: t
}) {
  const { loginWithPopup: n } = Re(), { t: s } = Hn();
  return /* @__PURE__ */ ne.jsxs("div", { className: "kitbag-auth_login--button", children: [
    r && !t && /* @__PURE__ */ ne.jsx(
      "button",
      {
        type: "button",
        onClick: () => n(),
        title: s("login"),
        children: s("login")
      }
    ),
    e && /* @__PURE__ */ ne.jsx("p", { className: "kitbag-auth_login--message", children: e })
  ] });
}
const Jn = (r) => A.t(r), we = Jn, Yn = ({
  rolesAllocatedToUser: r,
  allowed: e
}) => e ? (typeof e == "string" ? [e] : e).some(
  (t) => r.includes(t)
) : !1, Gn = we("defaultError"), qn = we("loading"), Qn = /* @__PURE__ */ ne.jsx(Bn, { message: "", isLoading: !1 }), Xn = we("unauthenticated"), Zn = we("notAuthorised");
function er({
  allowed: r,
  claimsURI: e = null,
  children: t,
  customisedError: n = Gn,
  customisedLoading: s = qn,
  customisedLogin: i = Qn,
  customisedUnauthenticated: o = Xn,
  customisedUnauthorised: u = Zn,
  displayErrors: l = !0,
  displayLoading: f = !0,
  displayLogin: d = !0
}) {
  const { user: h, isLoading: c, error: y, isAuthenticated: m } = Re();
  if (c)
    return f ? te.cloneElement(i, {
      displayLogin: d,
      isLoading: c,
      message: s
    }) : null;
  if (y)
    return l ? te.cloneElement(i, {
      displayLogin: d,
      isLoading: c,
      message: n
    }) : null;
  if (!m)
    return l ? te.cloneElement(i, {
      displayLogin: d,
      isLoading: c,
      message: o
    }) : null;
  if (m) {
    if (r && e) {
      const R = (h && h[e] ? h[e] : { roles: [] }).roles || [];
      if (!Yn({ allowed: r, rolesAllocatedToUser: R }))
        return l ? te.cloneElement(i, {
          displayLogin: d,
          isLoading: c,
          message: u
        }) : null;
    }
    return t;
  }
  return null;
}
function tr({ providerOptions: r, children: e }) {
  return /* @__PURE__ */ ne.jsx(Gt, { ...r, children: e });
}
function nr({
  loading: r,
  children: e,
  redirectOptions: t
}) {
  const { isAuthenticated: n, isLoading: s, loginWithRedirect: i } = Re();
  return be(() => {
    !n && !s && i(t);
  }, [n, s, i]), s ? r : n ? e : null;
}
function rr({
  element: r,
  redirectComponent: e
}) {
  const t = mt(r, {
    onRedirecting: () => e
  });
  return /* @__PURE__ */ ne.jsx(t, {});
}
const ar = {
  AuthProtected: nr,
  AuthProtectedComponent: er,
  AuthProtectedRoute: rr,
  AuthProvider: tr,
  useKitbagAuth: Re,
  User: qt,
  withAuthenticationRequired: mt
};
export {
  nr as AuthProtected,
  er as AuthProtectedComponent,
  rr as AuthProtectedRoute,
  tr as AuthProvider,
  lr as User,
  ar as default,
  Re as useKitbagAuth,
  fr as withAuthenticationRequired
};
